import React from 'react';
import logo from '../assets/images/logo-(primary-gradient).png'
export default function NoID(){
  return (
    <div id="no-id">
      <img src={logo} alt="EyeSee"/>
    </div>
  )
}
